import { render, staticRenderFns } from "./LetterEdit.vue?vue&type=template&id=05b38e57&scoped=true&"
import script from "./LetterEdit.vue?vue&type=script&lang=js&"
export * from "./LetterEdit.vue?vue&type=script&lang=js&"
import style0 from "./LetterEdit.vue?vue&type=style&index=0&id=05b38e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b38e57",
  null
  
)

export default component.exports